var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleWithSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16c0 5.523-4.477 10-10 10a9.959 9.959 0 01-6.329-2.257L23.743 9.67A9.959 9.959 0 0126 16zM8.257 22.328L22.328 8.257A9.958 9.958 0 0016 6C10.477 6 6 10.477 6 16c0 2.401.846 4.605 2.257 6.328zM28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12z",
    fill: "#1A1A1A"
  })));
}

export default SvgCircleWithSlash;